import { ScrollingModule } from '@angular/cdk/scrolling';
import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input, output } from '@angular/core';
import { EllipsisDirective } from '../../../directives/ellipsis/ellipsis';
import { TextSearchService } from '../../../services/text-search/text-search';

interface SearchResult {
  before: string;
  word: string;
  after: string;
  percentage: number;
  chapterName: string;
}

@Component({
  selector: 'nr-search-results',
  imports: [DecimalPipe, ScrollingModule, EllipsisDirective],
  templateUrl: './search-results.html',
  styleUrl: './search-results.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchResultsComponent {
  private readonly textSearchService = inject(TextSearchService);
  readonly searchResults = this.textSearchService.searchResults;
  readonly toggleShowResults = output();
  readonly index = input(0);

  readonly selectedWord = this.textSearchService.wordToSearch;
  readonly resultsContext = computed<SearchResult[] | undefined>(() => {
    const word = this.selectedWord();

    if (!this.searchResults.hasValue()) {
      return undefined;
    }
    return this.searchResults.value().map((result) => {
      const contextText = result.context;
      const wordIndex = contextText.toLowerCase().indexOf(word.toLowerCase());

      if (wordIndex === -1) {
        return {
          before: contextText,
          word: '',
          after: '',
          percentage: result.position * 100,
          chapterName: result.chapterName,
        };
      }

      return {
        before: contextText.substring(0, wordIndex),
        word: contextText.substring(wordIndex, wordIndex + word.length),
        after: contextText.substring(wordIndex + word.length),
        percentage: result.position * 100,
        chapterName: result.chapterName,
      };
    });
  });

  goToSelectedSearchResult(index: number): void {
    this.textSearchService.indexSearch.set(index);
    this.toggleShowResults.emit();
  }
}
